module.exports = __webpack_public_path__ + "img/bin.e8862b23.svg";